// inputs.js
import { validateRequired, validateLength } from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Descripcion",
    name: "tal_descripcion",
    type: "text",
    placeholder: "Ingrese el nombre del talle",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  }
  // Agrega más campos aquí
];

export default Inputs;
